import { createReducer } from "Store";
import update from "immutability-helper";

import {
    SET_HOVER,
    SET_DIMS,
    SET_FIXED_DIMS,
    HoverElement,
    SetDimsAction,
    DimElement,
    DimActionElement,
} from "./actionTypes";

// Async Reducer
export const hoverIndexes = createReducer(
    { row: -1, col: -1 },
    {
        [SET_HOVER](_: HoverElement, action: { data: {} }) {
            return action.data;
        },
    }
);

const setDims = (state: DimElement, action: { data: DimActionElement }) => {
    let data = action.data;
    let elementHeight = data.el.clientHeight + 1;

    state = update(state, {
        height: (oldHeight: number[]) => {
            oldHeight[data.rowIndex] = elementHeight;
            return oldHeight;
        },
    });

    if (data.rowIndex === 0) {
        state = update(state, {
            width: { $set: data.width },
        });
    }

    return state;
};

// Async Reducer
export const tableDims = createReducer(
    { height: [], width: [] },
    {
        [SET_DIMS](state: DimElement, action: SetDimsAction) {
            return setDims(state, action);
        },
    }
);

export const fixedTableDims = createReducer(
    { height: [], width: [] },
    {
        [SET_FIXED_DIMS](state: DimElement, action: SetDimsAction) {
            return setDims(state, action);
        },
    }
);
